"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFederatedAuthProvider = exports.AuthProvidersByProviderName = exports.federatedAuthProviders = exports.AUTH_PROVIDER_ATTRIBUTE_NAME = exports.SAML_PROVIDER_NAME = exports.OKTA_PROVIDER_NAME = exports.APPLE_PROVIDER_NAME = exports.GOOGLE_PROVIDER_NAME = exports.COGNITO_PROVIDER_NAME = exports.ADMIN_PRE_SIGNUP_TRIGGER = exports.THIRD_PARTY_PRE_SIGNUP_TRIGGER = exports.PRE_AUTH_TRIGGER = void 0;
exports.PRE_AUTH_TRIGGER = 'PreAuthentication_Authentication';
exports.THIRD_PARTY_PRE_SIGNUP_TRIGGER = 'PreSignUp_ExternalProvider';
exports.ADMIN_PRE_SIGNUP_TRIGGER = 'PreSignUp_AdminCreateUser';
// Comments from https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/CognitoIdentityServiceProvider.html#adminLinkProviderForUser-property
// The ProviderName should be set to Cognito for users in Cognito user pools.
exports.COGNITO_PROVIDER_NAME = 'Cognito';
exports.GOOGLE_PROVIDER_NAME = 'Google';
exports.APPLE_PROVIDER_NAME = 'SignInWithApple';
exports.OKTA_PROVIDER_NAME = 'Okta';
exports.SAML_PROVIDER_NAME = 'SAML';
// If the SourceUser is a federated social identity provider user, you must set the ProviderAttributeName to Cognito_Subject
exports.AUTH_PROVIDER_ATTRIBUTE_NAME = 'Cognito_Subject';
exports.federatedAuthProviders = [
    'Google',
    'Apple',
    'Okta',
    'SAML',
];
/**
 * Maps provider name (used internally) to provider's common name
 * e.g SignInWithApple -> Apple
 */
exports.AuthProvidersByProviderName = {
    [exports.COGNITO_PROVIDER_NAME]: 'Cognito',
    [exports.GOOGLE_PROVIDER_NAME]: 'Google',
    [exports.APPLE_PROVIDER_NAME]: 'Apple',
    [exports.OKTA_PROVIDER_NAME]: 'Okta',
    [exports.SAML_PROVIDER_NAME]: 'SAML',
};
/**
 * Type guard checking whether an authProvider is federated
 * @param authProvider
 */
const isFederatedAuthProvider = (authProvider) => exports.federatedAuthProviders.includes(authProvider);
exports.isFederatedAuthProvider = isFederatedAuthProvider;
//# sourceMappingURL=cognito.js.map